import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/marketing/paid-advertising")({
  component: () => <Outlet />,
});
